import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { IconWithTooltip, Text } from 'components/common/Elements/Elements';
import { useRegionalLink } from 'hooks/useRegionalLink';

import classes from './SettingsLink.module.scss';

const SettingsLink = () => {
  const { t } = useTranslation('settings');
  const generateRegionalPath = useRegionalLink();

  return (
    <Link to={generateRegionalPath('/settings/users')} className={classes.link}>
      <Text className={classes.visually_hidden}>
        {t('settings:TITLE_HEADING_SETTINGS')}
      </Text>
      <IconWithTooltip
        icon="icons2/icon_settingsIn.svg"
        iconFromMNX
        color="#546491"
        text={t('settings:TITLE_HEADING_SETTINGS')}
        className={classes.link_content}
      />
    </Link>
  );
};

export default SettingsLink;
